module.exports = __webpack_public_path__ + "files/de0b9014791d86012c7d99573bc3737b.png";